import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { notesService } from '../services/notes.service';
import { segmentKeys } from './useSegments';
import type { SaveNotePayload, NoteType } from '../types/api.types';

export function useSaveNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: SaveNotePayload) => notesService.saveNote(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: segmentKeys.all });
      toast.success('Note saved');
    },
    onError: (error: Error) => {
      toast.error(`Failed to save note: ${error.message}`);
    },
  });
}

export function useDeleteNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ segmentId, noteType }: { segmentId: number; noteType: NoteType }) =>
      notesService.deleteNote(segmentId, noteType),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: segmentKeys.all });
      toast.success('Note deleted');
    },
    onError: (error: Error) => {
      toast.error(`Failed to delete note: ${error.message}`);
    },
  });
}
